// Chunk-Basis-URL: window.beastSearch wird in Content/Scripts.twig VOR dem
// Bundle gesetzt (plugin_path + /js/dist/).
__webpack_public_path__ = window.beastSearch
